import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountsService} from "../../../account/services/accounts-service.service";
import {AccountsAlerts} from "../../../account/services/accounts-alerts.service";
import {AccountDialogService} from "../../../account/services/account-dialogs-service.service";
import {$accountsFactory} from "../../../account/$accounts.factory";
import {$accountFactory} from "../../../account/$account.factory";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {DepotsAlerts} from "../../services/depots-alerts.service";
import {AccountModel} from "../../../account/angular/models/account.model";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class depotShipperAccountsViewCtrl implements IController {

  depot: any;

  private accountsRef: any;
  private loadLimit: any;
  private accountIds: any;
  private type: any;
  private queryString: any;
  private infiniteScroll: any;
  private canRemove: any;

  /* @ngInject */
  constructor(private accountDialogService: AccountDialogService, private depotsAlerts: DepotsAlerts, private accountsAlerts: AccountsAlerts,
              private accountsService: AccountsService,
              private $log, private bringozLoaderService: BringozLoaderService, private IAMPermissions, private $account: $accountFactory,
              private $accounts: $accountsFactory, private confirmDialogService: ConfirmDialogService, private $infiniteScroll) {

    this.accountsRef = this.$accounts();
  }

  $onInit() {
    this.loadLimit = 30;

    this.accountIds = [];
    this.type = undefined;
    this.queryString = undefined;

    this.accountsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.accountsRef, this.loadLimit);

    this.canRemove = this.IAMPermissions.hasPermission('accounts.demand.update');
    this._getAccountIds(200).then((ids) => {
      this.accountIds = ids;
    })
  }


  onQueryChange(query) {
    this.queryString = query;
    this._query();
  }

  onInviteAccount(event) {
    this.accountDialogService.addDemandAccounts(event, this.accountIds, true)
      .then((payload) => {
        return this._addAccountsToDepot(this.depot.id, payload.ids, payload.excludeIds);
      })
  }

  onCreateAccountToDepot(event) {
    this.accountDialogService.createShipperAccount(event, undefined, this.depot.id)
      .then((createdAccount) => {
        return this.accountsRef.$getAll(this._getQueryPayload());
      })
      .then((updatedAccountIds) => {
        this.accountIds = updatedAccountIds;
      })
      .catch((error) => {
        if (error) {
          this.accountsAlerts.demandCreateError(error);
          this.$log.error('Failed to get shipper accounts ' +
            '@depotShipperAccountsView@onCreateAccountToDepot', error);
        } else {
          this.$log.info('Dialog Closed')
        }
      })
  }

  onRemoveAccount(account, event) {
    this.confirmDialogService.confirm('Remove Account', 'Are you sure you want to remove this account from depot?', event)
      .then(() => {
        this._removeAccountFromDepot(account)
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  private _query() {
    this.accountsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Fail to $query', error);
        }
      })
  }

  private _addAccountsToDepot(depotId, accountIds, excludeIds) {
    this.accountsService.addDepotToAccounts(depotId, accountIds, excludeIds)
      .then((accounts) => {
        let idsAdded = _.map(accounts, 'id');

        this.accountIds = this.accountIds.concat(idsAdded);
        this._addItems(idsAdded);
      })
  }

  private _removeAccountFromDepot(account: AccountModel) {
    var accountCopy = angular.copy(account);
    accountCopy.depotIds = _.without(account.depotIds, this.depot.id);

    this.bringozLoaderService.on();
    this.$account(account.id).$update(accountCopy)
      .then(() => {
        this.accountsAlerts.demandRemoveSuccess(account);

        this._removeItems([account.id]);
        this.accountIds = _.filter(this.accountIds, (id) => {
          return id !== account.id;
        })
      })
      .catch((error) => {
        this.accountsAlerts.demandRemoveError();
        this.$log.info('Failed to remove account from depot ' +
          '@depotShipperAccountsView@onRemoveAccount', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  private _addItems(ids) {
    this.infiniteScroll.addItems(ids);
  }

  private _removeItems(ids) {
    this.infiniteScroll.removeItems(ids)
  }


  private _getQueryPayload(limit?) {
    return {
      limit:  limit || this.loadLimit,
      isDemand:   true,
      type:       this.type,
      query:      this.queryString,
      depotIds:   [this.depot.id]
    };
  }

  private _getAccountIds(limit) {
    // return this.accountsRef.$getAll(this._getQueryPayload(limit));
    return this.accountsService.getAll(this._getQueryPayload(limit));
  }

}

angular
  .module('bringoz.admin.depots')
  .component('depotShipperAccountsView', {
    bindings: {
      depot: '<'
    },
    template: require('./depot-shipper-accounts-view.html').default,
    controller: depotShipperAccountsViewCtrl
  });
